import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useTireSetStore = defineStore('tireSet', () => {
    const all = ref(null);
    const current = ref(null);

    const actions = {
        search: (params) => axios.get('/api/v1/tire-sets', { params }),
        checkIn: (params) => axios.post('/api/v1/tire-sets', params),
        show: (hash) => axios.get('/api/v1/tire-sets/' + hash),
        customerVehicles: (customerHash) => axios.get('/api/v1/customers/' + customerHash + '/vehicles'),
        addNote: (setHash, params) => axios.post('/api/v1/tire-sets/' + setHash + '/notes', params),
        deleteNote: (setHash, noteHash) => axios.delete('/api/v1/tire-sets/' + setHash + '/notes/' + noteHash),
        uploadPhoto: (setHash, formData) => axios.post('/api/v1/tire-sets/' + setHash + '/media', formData),
        deletePhoto: (setHash, mediaHash) => axios.delete('/api/v1/tire-sets/' + setHash + '/media/' + mediaHash),
    };

    return {
        all,
        current,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useTireSetStore.acceptHMRUpdate);
}
